import { jsonPost } from 'fetch_utils';

import { CartDrawerItem } from './types';

const API_FETCH_CART_DRAWER_ITEMS = '/api/v4/cart/mini';
export const apiFetchCartDrawerItems = (): Promise<{
  response?: {
    data: {
      cart_item_count: number;
      recent_cart_item_details: CartDrawerItem[];
    };
  };
  error?: number | null;
}> => {
  return jsonPost(API_FETCH_CART_DRAWER_ITEMS);
};
